<div class="dual-list">
	<div class="listbox">
		<small class="text-left">{{sourceName}}</small>
		<div class="record-picker custom-picker available">
			<ul [ngStyle]="{'max-height': height, 'min-height': height}" [ngClass]="{over:available.dragOver}"
				(drop)="drop($event, confirmed)" (dragover)="allowDrop($event, available)" (dragleave)="dragLeave()">
				<li *ngFor="let item of available.sift; let idx=index;"
					(click)="selectItem(available.pick, item); shiftClick($event, idx, available, item)"
					[ngClass]="{selected: isItemSelected(available.pick, item)}"
					draggable="true" (dragstart)="drag($event, item, available)" (dragend)="dragEnd(available)"
				><label>
					<app-custom-icons *ngIf="item._type" [icon]="item._type +'.svg'" [color]="'#e97e97'" [size]="'14px'" class="d-inline-block"></app-custom-icons>
					<app-custom-icons *ngIf="!item._type" [icon]="'prize.svg'" [color]="'#e97e97'" [size]="'14px'" class="d-inline-block"></app-custom-icons>
					{{item._name}}
				</label></li>	
			</ul>
		</div>
	</div>

	<div class="buttonbox">
		<button type="button" class="btn btn-block" (click)="moveItem(available, confirmed)" 
			[disabled]="available.pick.length === 0"><i class="fa fa-arrow-right"></i></button>
		
		<button type="button" class="btn btn-block" (click)="moveItem(confirmed, available)"
			[disabled]="confirmed.pick.length === 0"><i class="fa fa-arrow-left"></i></button>
	</div>

	<div class="listbox">
		<small class="text-left">{{targetName}}</small>
		<div class="record-picker custom-picker confirmed">
			<ul [ngStyle]="{'max-height': height, 'min-height': height}" [ngClass]="{over:confirmed.dragOver}"
				(drop)="drop($event, available)" (dragover)="allowDrop($event, confirmed)" (dragleave)="dragLeave()">
				<li *ngFor="let item of confirmed.sift; let idx=index;"
					(click)="selectItem(confirmed.pick, item); shiftClick($event, idx, confirmed, item)"
					[ngClass]="{selected: isItemSelected(confirmed.pick, item)}"
					draggable="true" (dragstart)="drag($event, item, confirmed)" (dragend)="dragEnd(confirmed)"
				><label>
					<app-custom-icons *ngIf="item._type" [icon]="item._type +'.svg'" [color]="'#e97e97'" [size]="'14px'" class="d-inline-block"></app-custom-icons>
					<app-custom-icons *ngIf="!item._type" [icon]="'prize.svg'" [color]="'#e97e97'" [size]="'14px'" class="d-inline-block"></app-custom-icons>
					{{item._name}}
				</label></li>
			</ul>
		</div>
	</div>
</div>